var A = Object.defineProperty;
var T = a => {
    throw TypeError(a)
};
var z = (a, s, t) => s in a ? A(a, s, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
}) : a[s] = t;
var S = (a, s, t) => z(a, typeof s != "symbol" ? s + "" : s, t),
    $ = (a, s, t) => s.has(a) || T("Cannot " + t);
var h = (a, s, t) => ($(a, s, "read from private field"), t ? t.call(a) : s.get(a)),
    g = (a, s, t) => s.has(a) ? T("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(a) : s.set(a, t),
    C = (a, s, t, e) => ($(a, s, "write to private field"), e ? e.call(a, t) : s.set(a, t), t);
import "./ll-product-form-yWOzeAST.js";
customElements.get("product-info") || customElements.define("product-info", class extends HTMLElement {
    constructor() {
        super();
        S(this, "quantityInput");
        S(this, "quantityForm");
        S(this, "onVariantChangeUnsubscriber");
        S(this, "cartUpdateUnsubscriber");
        S(this, "abortController");
        S(this, "pendingRequestUrl", null);
        S(this, "preProcessHtmlCallbacks", []);
        S(this, "postProcessHtmlCallbacks", []);
        this.quantityInput = this.querySelector(".quantity__input")
    }
    connectedCallback() {
        this.initializeProductSwapUtility(), this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this)), this.initQuantityHandlers(), this.dispatchEvent(new CustomEvent("product-info:loaded", {
            bubbles: !0
        }))
    }
    addPreProcessCallback(t) {
        this.preProcessHtmlCallbacks.push(t)
    }
    initQuantityHandlers() {
        this.quantityInput && (this.quantityForm = this.querySelector(".product-form__quantity"), this.quantityForm && (this.setQuantityBoundries(), this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this)))))
    }
    disconnectedCallback() {
        var t;
        this.onVariantChangeUnsubscriber(), (t = this.cartUpdateUnsubscriber) == null || t.call(this)
    }
    initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push(t => t.querySelectorAll(".scroll-trigger").forEach(e => e.classList.add("scroll-trigger--cancel"))), this.postProcessHtmlCallbacks.push(t => {
            var e, i, o;
            (i = (e = window == null ? void 0 : window.Shopify) == null ? void 0 : e.PaymentButton) == null || i.init(), (o = window == null ? void 0 : window.ProductModel) == null || o.loadShopifyXR()
        })
    }
    handleOptionValueChange({
        data: {
            event: t,
            target: e,
            selectedOptionValues: i
        }
    }) {
        if (!this.contains(t.target)) return;
        this.resetProductFormState();
        const o = e.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = o;
        const n = this.dataset.url !== o,
            r = this.dataset.updateUrl === "true" && n;
        this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(o, i, r),
            targetId: e.id,
            callback: n ? this.handleSwapProduct(o, r) : this.handleUpdateProductInfo(o)
        })
    }
    resetProductFormState() {
        const t = this.productForm;
        t == null || t.toggleSubmitButton(!0), t == null || t.handleErrorMessage()
    }
    handleSwapProduct(t, e) {
        return i => {
            var r;
            (r = this.productModal) == null || r.remove();
            const o = e ? "product-info[id^='MainProduct']" : "product-info",
                n = this.getSelectedVariant(i.querySelector(o));
            this.updateURL(t, n == null ? void 0 : n.id), e ? (document.querySelector("head title").innerHTML = i.querySelector("head title").innerHTML, HTMLUpdateUtility.viewTransition(document.querySelector("main"), i.querySelector("main"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)) : HTMLUpdateUtility.viewTransition(this, i.querySelector("product-info"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)
        }
    }
    renderProductInfo({
        requestUrl: t,
        targetId: e,
        callback: i
    }) {
        var o;
        (o = this.abortController) == null || o.abort(), this.abortController = new AbortController, fetch(t, {
            signal: this.abortController.signal
        }).then(n => n.text()).then(n => {
            this.pendingRequestUrl = null;
            const r = new DOMParser().parseFromString(n, "text/html");
            i(r)
        }).then(() => {
            var n;
            (n = document.querySelector(`#${e}`)) == null || n.focus()
        }).catch(n => {
            n.name
        })
    }
    getSelectedVariant(t) {
        var i;
        const e = (i = t.querySelector("variant-selects [data-selected-variant]")) == null ? void 0 : i.innerHTML;
        return e ? JSON.parse(e) : null
    }
    buildRequestUrlWithParams(t, e, i = !1) {
        const o = [];
        return !i && o.push(`section_id=${this.sectionId}`), e.length && o.push(`option_values=${e.join(",")}`), `${t}?${o.join("&")}`
    }
    updateOptionValues(t) {
        const e = t.querySelector("variant-selects");
        e && HTMLUpdateUtility.viewTransition(this.variantSelectors, e, this.preProcessHtmlCallbacks)
    }
    handleUpdateProductInfo(t) {
        return e => {
            var n, r, l, d, b, m;
            const i = this.getSelectedVariant(e);
            if ((n = this.pickupAvailability) == null || n.update(i), this.updateOptionValues(e), this.updateURL(t, i == null ? void 0 : i.id), this.updateVariantInputs(i == null ? void 0 : i.id), !i) {
                this.setUnavailable();
                return
            }
            this.updateMedia(e, (r = i == null ? void 0 : i.featured_media) == null ? void 0 : r.id);
            const o = (c, f = p => !1) => {
                const p = e.getElementById(`${c}-${this.sectionId}`),
                    u = this.querySelector(`#${c}-${this.dataset.section}`);
                p && u && (u.innerHTML = p.innerHTML, u.classList.toggle("hidden", f(p)))
            };
            o("price"), o("Sku", ({
                classList: c
            }) => c.contains("hidden")), o("Inventory", ({
                innerText: c
            }) => c === ""), o("Volume"), o("Price-Per-Item", ({
                classList: c
            }) => c.contains("hidden")), this.updateQuantityRules(this.sectionId, e), (l = this.querySelector(`#Quantity-Rules-${this.dataset.section}`)) == null || l.classList.remove("hidden"), (d = this.querySelector(`#Volume-Note-${this.dataset.section}`)) == null || d.classList.remove("hidden"), (m = this.productForm) == null || m.toggleSubmitButton(((b = e.getElementById(`ProductSubmitButton-${this.sectionId}`)) == null ? void 0 : b.hasAttribute("disabled")) ?? !0, window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                    sectionId: this.sectionId,
                    html: e,
                    variant: i
                }
            })
        }
    }
    updateVariantInputs(t) {
        this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach(e => {
            const i = e.querySelector('input[name="id"]');
            i.value = t ?? "", i.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    updateURL(t, e) {
        var i;
        (i = this.querySelector("share-button")) == null || i.updateUrl(`${window.shopUrl}${t}${e?`?variant=${e}`:""}`), this.dataset.updateUrl !== "false" && window.history.replaceState({}, "", `${t}${e?`?variant=${e}`:""}`)
    }
    setUnavailable() {
        var e;
        (e = this.productForm) == null || e.toggleSubmitButton(!0, window.variantStrings.unavailable);
        const t = ["price", "Inventory", "Sku", "Price-Per-Item", "Volume-Note", "Volume", "Quantity-Rules"].map(i => `#${i}-${this.dataset.section}`).join(", ");
        document.querySelectorAll(t).forEach(({
            classList: i
        }) => i.add("hidden"))
    }
    updateMedia(t, e) {
        var d, b, m;
        if (!e) return;
        const i = this.querySelector("media-gallery ul"),
            o = t.querySelector("media-gallery ul"),
            n = () => {
                this.hasAttribute("data-zoom-on-hover") && enableZoomOnHover(2);
                const c = Array.from(i.querySelectorAll("li[data-media-id]")),
                    f = new Set(c.map(u => u.dataset.mediaId)),
                    p = new Map(c.map((u, U) => [u.dataset.mediaId, {
                        item: u,
                        index: U
                    }]));
                return [c, f, p]
            };
        if (i && o) {
            let [c, f, p] = n();
            const u = Array.from(o.querySelectorAll("li[data-media-id]")),
                U = new Set(u.map(({
                    dataset: y
                }) => y.mediaId));
            let P = !1;
            for (let y = u.length - 1; y >= 0; y--) f.has(u[y].dataset.mediaId) || (i.prepend(u[y]), P = !0);
            for (let y = 0; y < c.length; y++) U.has(c[y].dataset.mediaId) || (c[y].remove(), P = !0);
            P && ([c, f, p] = n()), u.forEach((y, H) => {
                const M = p.get(y.dataset.mediaId);
                M && M.index !== H && (i.insertBefore(M.item, i.querySelector(`li:nth-of-type(${H+1})`)), [c, f, p] = n())
            })
        }(b = (d = this.querySelector("media-gallery")) == null ? void 0 : d.setActiveMedia) == null || b.call(d, `${this.dataset.section}-${e}`, !0);
        const r = (m = this.productModal) == null ? void 0 : m.querySelector(".product-media-modal__content"),
            l = t.querySelector("product-modal .product-media-modal__content");
        r && l && (r.innerHTML = l.innerHTML)
    }
    setQuantityBoundries() {
        const t = {
            cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
            min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
            max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
            step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1
        };
        let e = t.min;
        const i = t.max === null ? t.max : t.max - t.cartQuantity;
        i !== null && (e = Math.min(e, i)), t.cartQuantity >= t.min && (e = Math.min(e, t.step)), this.quantityInput.min = e, i ? this.quantityInput.max = i : this.quantityInput.removeAttribute("max"), this.quantityInput.value = e, publish(PUB_SUB_EVENTS.quantityUpdate, void 0)
    }
    fetchQuantityRules() {
        var e, i;
        const t = (i = (e = this.productForm) == null ? void 0 : e.variantIdInput) == null ? void 0 : i.value;
        t && (this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden"), fetch(`${this.dataset.url}?variant=${t}&section_id=${this.dataset.section}`).then(o => o.text()).then(o => {
            const n = new DOMParser().parseFromString(o, "text/html");
            this.updateQuantityRules(this.dataset.section, n)
        }).catch(o => {}).finally(() => this.querySelector(".quantity__rules-cart .loading__spinner").classList.add("hidden")))
    }
    updateQuantityRules(t, e) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();
        const i = e.getElementById(`Quantity-Form-${t}`),
            o = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let n of o) {
            const r = this.quantityForm.querySelector(n),
                l = i.querySelector(n);
            if (!(!r || !l))
                if (n === ".quantity__input") {
                    const d = ["data-cart-quantity", "data-min", "data-max", "step"];
                    for (let b of d) {
                        const m = l.getAttribute(b);
                        m !== null ? r.setAttribute(b, m) : r.removeAttribute(b)
                    }
                } else r.innerHTML = l.innerHTML
        }
    }
    get productForm() {
        return this.querySelector("product-form")
    }
    get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`)
    }
    get pickupAvailability() {
        return this.querySelector("pickup-availability")
    }
    get variantSelectors() {
        return this.querySelector("variant-selects")
    }
    get relatedProducts() {
        const t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "related-products");
        return document.querySelector(`product-recommendations[data-section-id^="${t}"]`)
    }
    get quickOrderList() {
        const t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "quick_order_list");
        return document.querySelector(`quick-order-list[data-id^="${t}"]`)
    }
    get sectionId() {
        return this.dataset.originalSection || this.dataset.section
    }
});
!customElements.get("ll-product-info") && customElements.get("product-info") && customElements.define("ll-product-info", class extends customElements.get("product-info") {
    constructor() {
        super()
    }
    connectedCallback() {
        super.connectedCallback(), this.renderRechargeSubscriptionWidget(this)
    }
    renderRechargeSubscriptionWidget(s) {
        if (!this.rechargeContainer) return;
        const t = s.dataset.hasDiscount === "true";
        this.rechargeContainer.style.display = t ? "none" : "block"
    }
    renderBuyButtons(s) {
        const t = s.getElementById(`ProductSubmitButton-${this.sectionId}`),
            e = document.querySelector(".recharge-subscription-widget"),
            i = this.querySelectorAll(".ll-product-form__button--visible-if-available"),
            o = document.querySelector("ll-zooomy-wishlist"),
            n = document.querySelector('[data-tag="wishlist-placeholder"]'),
            r = (t == null ? void 0 : t.hasAttribute("disabled")) ?? !0;
        o && o.isZooomyLoaded() && (o.dataset.displayFullWidth = r, o.renderZooomyLabel()), r ? (e == null || e.classList.add("hidden"), i.forEach(l => {
            l.classList.add("hidden")
        }), n && (n.classList.remove("ll-product-form__button--wishlist"), n.classList.add("ll-product-form__button--full-width-wishlist"))) : (e == null || e.classList.remove("hidden"), i.forEach(l => {
            l.classList.remove("hidden")
        }), n && (n.classList.remove("ll-product-form__button--full-width-wishlist"), n.classList.add("ll-product-form__button--wishlist")))
    }
    handleUpdateProductInfo(s) {
        return t => {
            var e;
            super.handleUpdateProductInfo(s)(t);
            try {
                this.renderRechargeSubscriptionWidget(t.querySelector("ll-product-info")), this.renderBuyButtons(t)
            } catch {
                (e = this.productForm) == null || e.handleErrorMessage("Unable to update the page properly. Please refresh the page.")
            }
        }
    }
    updateOptionValues(s) {
        super.updateOptionValues(s);
        const t = this.getSelectedVariant(s);
        (t == null ? void 0 : t.compare_at_price) != (t == null ? void 0 : t.price) && this.ensureSubscriptionIsUnchecked(), this.updateShareLinks(t)
    }
    updateShareLinks(s) {
        var l;
        const t = this.querySelector('[data-share="facebook"]'),
            e = this.querySelector('[data-share="twitter"]'),
            i = this.querySelector('[data-share="pinterest"]'),
            o = window.location.href,
            n = s.name,
            r = (l = s.featured_image) == null ? void 0 : l.src;
        t && (t.href = `//www.facebook.com/sharer.php?u=${encodeURIComponent(o)}`), e && (e.href = `//twitter.com/share?text=${encodeURIComponent(n)}&url=${encodeURIComponent(o)}`), i && r && (i.href = `//pinterest.com/pin/create/button/?url=${encodeURIComponent(o)}&media=${encodeURIComponent(r)}&description=${encodeURIComponent(n)}`)
    }
    ensureSubscriptionIsUnchecked() {
        const s = document.querySelector("label.onetime-radio");
        s && s.click();
        const t = document.querySelector("input[name='selling_plan']");
        t && (t.value = "", t.dispatchEvent(new Event("change", {
            bubbles: !0
        })))
    }
    updateVariantInputs(s) {
        super.updateVariantInputs(s), this.querySelectorAll('[data-type="add-to-cart-form"]').forEach(t => {
            const e = t.querySelector('input[name="id"]');
            e.value = s ?? "", e.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    handleSwapProduct(s, t) {
        return e => {
            var n;
            (n = this.productModal) == null || n.remove();
            const i = t ? "ll-product-info[id^='MainProduct']" : "ll-product-info",
                o = this.getSelectedVariant(e.querySelector(i));
            this.updateURL(s, o == null ? void 0 : o.id), t ? (document.querySelector("head title").innerHTML = e.querySelector("head title").innerHTML, HTMLUpdateUtility.viewTransition(document.querySelector("main"), e.querySelector("main"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)) : HTMLUpdateUtility.viewTransition(this, e.querySelector("ll-product-info"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)
        }
    }
    get rechargeContainer() {
        return this.querySelector(".recharge-subscription-widget")
    }
    get productForm() {
        return this.querySelector("ll-product-form")
    }
});
class R extends HTMLElement {
    constructor() {
        super(), this.caretIconHtml = this.querySelector('script[type="text/html"][data-product="caret-icon"]').innerHTML, this.decoratedContent = this.querySelector('[data-product="content-decorated"]'), this.baseContent = this.querySelector('[data-product="content-basis"]')
    }
    connectedCallback() {
        this.render()
    }
    decorateContent() {
        const s = this.baseContent.innerHTML,
            e = new DOMParser().parseFromString(s, "text/html"),
            i = document.createDocumentFragment();
        let o = null,
            n = 0;
        if (e.body.childNodes.forEach(r => {
                if (r.nodeType === Node.ELEMENT_NODE && /^H[1-6]$/.test(r.tagName)) {
                    const l = `content-${n}`;
                    if (o) {
                        if (n >= 2) {
                            const u = document.createElement("hr");
                            u.classList.add("content-decorated__divider"), i.appendChild(u)
                        }
                        i.appendChild(o)
                    }
                    n += 1, o = document.createElement("div"), o.classList.add("content-decorated__section");
                    const d = document.createElement("input");
                    d.type = "checkbox", d.classList.add("content-decorated__toggle"), n <= 1 && (d.checked = !0);
                    const b = r.cloneNode(!0),
                        m = document.createElement("label");
                    m.classList.add("content-decorated__toggle-label"), m.textContent = b.textContent;
                    const c = document.createElement("span");
                    c.classList.add("content-decorated__caret-icon"), c.innerHTML = this.caretIconHtml;
                    const f = document.createElement("div");
                    f.classList.add("content-decorated__collapsible-content"), m.htmlFor = d.id = `toggle-${l}`, c.dataset.toggleWith = d.id, f.dataset.toggleWith = d.id;
                    const p = document.createElement("div");
                    p.classList.add("content-decorated__toggleable"), m.appendChild(c), p.appendChild(m), o.appendChild(d), p.appendChild(f), o.appendChild(p)
                } else if (o) {
                    const l = o.querySelector(".content-decorated__collapsible-content");
                    this.removeElementColorStyle(r), l.appendChild(r.cloneNode(!0))
                }
            }), o) {
            if (n >= 2) {
                const r = document.createElement("hr");
                r.classList.add("content-decorated__divider"), i.appendChild(r)
            }
            i.appendChild(o)
        }
        return i
    }
    removeElementColorStyle(s) {
        return s.style && (s.style.color = null), s.children && Array.from(s.children).forEach(t => {
            this.removeElementColorStyle(t)
        }), s
    }
    render() {
        const s = this.decorateContent();
        const ingredients = s.querySelectorAll("table td:first-child")
        if(ingredients){
            ingredients.forEach(ingredient => {
                const title = ingredient.innerText.split('-');
                if(title?.length > 1)
                    ingredient.innerHTML = `<strong><span class='ll-product-ingredient-first'>${title[0]}</span> - <span class='ll-product-ingredient-second'>${title[1]}</span></strong>`
            })
            s.hasChildNodes() ? (this.decoratedContent.innerHTML = "", this.decoratedContent.appendChild(s)) : this.decorateContent.innerHTML = this.baseContent.innerHTML
        }
    }
}
customElements.get("ll-product-description") || customElements.define("ll-product-description", R);
var q, E, L, w, x;
customElements.get("ll-zooomy-wishlist") || customElements.define("ll-zooomy-wishlist", (x = class extends HTMLElement {
    constructor() {
        super();
        g(this, q);
        g(this, E);
        g(this, L);
        g(this, w, 100);
        this.block = this.querySelector(`#shopify-block-${this.dataset.shopifyWishlistBlockId}`), this.zooomyInstance = this.querySelector("#ZlistWishlist"), this.placeholder = this.querySelector('[data-tag="wishlist-placeholder"]'), this.icon = this.querySelector("#wishlist-icon").innerHTML, this.iconChecked = this.querySelector("#wishlist-icon-checked").innerHTML, this.polledCount = 0
    }
    connectedCallback() {
        this.dataset.customerId && (C(this, E, this.pollZooomy.bind(this)), C(this, q, setInterval(h(this, E), 500)))
    }
    disconnectedCallback() {
        clearInterval(h(this, q)), this.zooomyDisconectedCallback()
    }
    isZooomyLoaded() {
        return this.zooomyInstance && this.zooomyInstance.querySelector("#ZooomyList")
    }
    pollZooomy() {
        this.isZooomyLoaded() ? (clearInterval(h(this, q)), this.zooomyConstruct(this.zooomyInstance.querySelector("#ZooomyList"))) : this.polledCount++, this.polledCount > h(this, w) && clearInterval(h(this, q))
    }
    zooomyConstruct(t) {
        this.placeholder.style.display = "none", this.block.style.display = "block", this.zooomyLabel = t.querySelector("label"), this.zooomyCheckbox = t.querySelector('input[type="checkbox"]'), this.renderZooomyLabel(), this.zooomyConnectedCallback()
    }
    onZooomyCheckboxChecked() {
        this.renderZooomyLabel()
    }
    renderZooomyLabel() {
        if (!this.zooomyCheckbox) return;
        const t = this.zooomyCheckbox.checked ? this.iconChecked : this.icon;
        if (this.dataset.displayFullWidth === "true") {
            const e = this.zooomyCheckbox.checked ? this.dataset.removeTitle : this.dataset.addTitle;
            this.zooomyLabel.innerHTML = `${t} <span>${e}</span>`, this.zooomyLabel.classList.remove("circle"), this.zooomyLabel.classList.add("full-width")
        } else this.zooomyLabel.innerHTML = t, this.zooomyLabel.classList.remove("full-width"), this.zooomyLabel.classList.add("circle")
    }
    zooomyConnectedCallback() {
        C(this, L, this.onZooomyCheckboxChecked.bind(this)), this.zooomyCheckbox.addEventListener("change", h(this, L))
    }
    zooomyDisconectedCallback() {
        h(this, L) && this.zooomyCheckbox.removeEventListener("change", h(this, L))
    }
    static get observedAttributes() {
        return ["data-display-full-width"]
    }
    attributeChangedCallback(t, e, i) {
        t === "data-display-full-width" && this.handleDisplayFullWidthChange(i)
    }
    handleDisplayFullWidthChange(t) {
        this.block && (t === "true" ? this.block.style.width = "100%" : this.block.style.width = "")
    }
}, q = new WeakMap, E = new WeakMap, L = new WeakMap, w = new WeakMap, x));
var k, I, v, _, B;
customElements.get("ll-subscription-notice-modal") || customElements.define("ll-subscription-notice-modal", (B = class extends HTMLElement {
    constructor() {
        super();
        g(this, k);
        g(this, I);
        g(this, v);
        g(this, _);
        this.closeButton = this.querySelector(".subscription-notice-modal__cancel-button"), this.submitButton = this.querySelector(".subscription-notice-modal__add-to-cart-button"), this.agreementCheckbox = this.querySelector("[name='subscription_agreement']"), this.onSubmit = () => {
            throw new Error("onSubmit not implemented")
        }
    }
    connectedCallback() {
        C(this, v, this.close.bind(this)), this.closeButton.addEventListener("click", h(this, v)), C(this, _, this.handleSubmit.bind(this)), this.submitButton.addEventListener("click", h(this, _)), C(this, k, this.handleAgreementCheck.bind(this)), this.agreementCheckbox.addEventListener("change", h(this, k)), this.handleAgreementCheck()
    }
    disconnectedCallback() {
        this.agreementCheckbox.removeEventListener("change", h(this, k)), this.closeButton.removeEventListener("click", h(this, v)), this.submitButton.removeEventListener("click", h(this, _))
    }
    open(t, e) {
        this.formData = t, this.onSubmit = e, this.hidden = !1, this.setAttribute("open", !0), C(this, I, this.handleOutsideClick.bind(this)), document.addEventListener("click", h(this, I))
    }
    handleAgreementCheck() {
        const t = this.querySelector("button[type='submit']");
        t.disabled = !this.agreementCheckbox.checked
    }
    handleOutsideClick(t) {
        t.target.contains(this) && this.close()
    }
    handleSubmit(t) {
        t.stopPropagation(), t.preventDefault(), this.onSubmit(this.formData), this.close()
    }
    close() {
        this.hidden = !0, this.removeAttribute("open"), document.removeEventListener("click", h(this, I))
    }
}, k = new WeakMap, I = new WeakMap, v = new WeakMap, _ = new WeakMap, B));